// @flow

import React from 'react';
import glamorous from 'glamorous';
import { css } from 'glamor';

const pulseAnimation = css.keyframes({
  '0%': {
    boxShadow: '0 0 0 0 rgba(255,255,255, 0.8)',
  },
  '70%': {
    boxShadow: '0 0 0 10px rgba(255,255,255, 0)',
  },
  '100%': {
    boxShadow: '0 0 0 0 rgba(255,255,255, 0)',
  },
});

const Wrapper = glamorous.div({
  // margin: 10,
  display: 'block',
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: 'white',
  boxShadow: '0 0 0 rgba(255,255,255, 0.8)',
  animation: `${pulseAnimation} 2s infinite`,
});

function Pulse({ className }) {
  return <Wrapper className={className} />;
}

export default Pulse;
